import {v4 as uuidv4} from 'uuid';


/**
 *
 */
const setupReadMore = () =>
{
	const containers = document.querySelectorAll( '[data-read-more-expand]' );
	const readMore   = `Read More <i class="fa-solid fa-caret-down"></i>`;
	const readLess   = `Read Less <i class="fa-solid fa-caret-up"></i>`;


	containers.forEach( container =>
	{
		if (container.getAttribute( 'data-initialized' ) === 'true') {
			return;
		}

		const id                 = 'read-more-' + uuidv4();
		const readMoreChildNodes = [];

		container.childNodes.forEach( child =>
		{
			if (readMoreChildNodes.length) {
				readMoreChildNodes.push( child );

			} else if (child instanceof HTMLElement && child.tagName === 'P' && child.innerHTML.match( /<!--\s*more\s*-->/ )) {
				readMoreChildNodes.push( document.createTextNode( '' ) );
			}
		} );

		if (readMoreChildNodes.length) {

			container.insertAdjacentHTML( 'beforeend', `
				<div class="collapse" id="${id}"></div>
				<p>
					<a class="btn btn-primary read-more-btn" data-bs-toggle="collapse" href="#${id}" role="button" aria-expanded="false" aria-controls="${id}">
						Read More
						<i class="fa-solid fa-caret-down"></i>
					</a>
				</p>
			` );

			const collapseContainer = container.querySelector( `#${id}` );
			const btn               = container.querySelector( `[href="#${id}"]` );

			if (collapseContainer instanceof HTMLElement) {
				readMoreChildNodes.forEach( childNode => collapseContainer.appendChild( childNode ) );
			}

			if (btn instanceof HTMLElement) {
				btn.addEventListener( 'click', () =>
				{
					btn.innerHTML = btn.classList.contains( 'collapsed' ) ? readMore : readLess;
				} );
			}
		}

		container.setAttribute( 'data-initialized', 'true' );
	} );
};


/**
 *
 */
export default setupReadMore;